$(function() {
  closeTopAnnoucementBar.init();
  fixednav.init();
  mobilemenu.init();
  headersmoosh.init();
  featureSlider.init();
});

//document.addEventListener('DOMContentLoaded',function(){

  var headersmoosh = {
    init: function(){

      var widthTopNavExtra = $('.top-nav-extra-ul_menu').width();
      $('.top-nav-ul_menu').css('margin-right', widthTopNavExtra+'px');

      const container = document.querySelector('.top-tabs')
      const primary = container.querySelector('.tabs-top-primary')
      const primaryItems = container.querySelectorAll('.tabs-top-primary > li:not(.top-more)')
      container.classList.add('top--jsfied')

      // insert "more" button and duplicate the list

      $('.top-more').remove();
      primary.insertAdjacentHTML('beforeend', `
        <li class="top-more">
          <button type="button" aria-haspopup="true" aria-expanded="false">
            More <span>&darr;</span>
          </button>
          <ul class="top-secondary">
            ${primary.innerHTML}
          </ul>
        </li>
      `)
      const secondary = container.querySelector('.top-secondary')
      const secondaryItems = secondary.querySelectorAll('li')
      const allItems = container.querySelectorAll('li')
      const moreLi = primary.querySelector('.top-more')
      const moreBtn = moreLi.querySelector('button')
      moreBtn.addEventListener('click', (e) => {
        e.preventDefault()
        container.classList.toggle('top--show-secondary')
        moreBtn.setAttribute('aria-expanded', container.classList.contains('top--show-secondary'))
      })

      // adapt tabs

      const doAdapt = () => {
        // reveal all items for the calculation
        allItems.forEach((item) => {
          item.classList.remove('top--hidden')
        })

        // hide items that won't fit in the Primary
        let stopWidth = moreBtn.offsetWidth
        let hiddenItems = []
        const primaryWidth = primary.offsetWidth
        primaryItems.forEach((item, i) => {
          if(primaryWidth >= stopWidth + item.offsetWidth) {
            stopWidth += item.offsetWidth
          } else {
            item.classList.add('top--hidden')
            hiddenItems.push(i)
          }
        })
        
        // toggle the visibility of More button and items in Secondary
        if(!hiddenItems.length) {
          moreLi.classList.add('top--hidden')
          container.classList.remove('top--show-secondary')
          moreBtn.setAttribute('aria-expanded', false)
        }
        else {  
          secondaryItems.forEach((item, i) => {
            if(!hiddenItems.includes(i)) {
              item.classList.add('top--hidden')
            }
          })
        }
      }

      doAdapt() // adapt immediately on load
      window.addEventListener('resize', doAdapt) // adapt on window resize

      // hide Secondary on the outside click

      document.addEventListener('click', (e) => {
        let el = e.target
        while(el) {
          if(el === secondary || el === moreBtn) {
            return;
          }
          el = el.parentNode
        }
        container.classList.remove('top--show-secondary')
        moreBtn.setAttribute('aria-expanded', false)
      })

    }
  }

//});


var closeTopAnnoucementBar = {
  init: function(){

    var announcement_barValue = localStorage.getItem('announcement_bar');
    var annoucement_text = $('#shopify-section-header > div.top-announcement_bar-wrapper > div.top-announcement_bar-text').text();

    if( announcement_barValue == null || announcement_barValue == '' || announcement_barValue != $('.top-announcement_bar-text').text() ){
      $('div.top-announcement_bar-wrapper').slideDown();
    }

    $('.top-announcement_bar-x').click(function() {
        $('div.top-announcement_bar-wrapper').slideUp();
        localStorage.setItem('announcement_bar', annoucement_text);
    });

  }
}


var fixednav = {
  init: function(){
    setTimeout(function(){
      //$('.fixed-nav').clone(true).appendTo('.clone-fixed-menu');
      var headerHeight = $('#shopify-section-header').height();
      $(window).scroll(function(){
        var scroll = $(window).scrollTop();
        if(scroll >= headerHeight){
          //$('.clone-fixed-menu').slideDown();
          $('#shopify-section-header').addClass('header-fixed-top');
          $('body').css('padding-top', headerHeight+'px');
          $('.top-announcement_bar-wrapper, .top-nav-wrapper, .main-menu-nav-wrapper').not('.fixed-nav').hide();
        }
        else{
          //$('.clone-fixed-menu').slideUp();
          $('#shopify-section-header').removeClass('header-fixed-top');
          $('body').css('padding-top', '0px');
          $('.top-announcement_bar-wrapper, .top-nav-wrapper, .main-menu-nav-wrapper').not('.fixed-nav').show();
        }
      });
    }, 250);
  }
}

var mobilemenu = {
  init: function(){

    var socialFontSize = $('.mobile-social-links-wrapper > a').children().length;
    $('.mobile-social-links-wrapper').addClass('social-num-length-'+socialFontSize);

    $('#mySidenav .closebtn').click(function() {
      document.getElementById("mySidenav").style.marginLeft = "-250px";
      document.body.style.marginLeft = "0";
      document.body.style.marginRight = "0";
      document.body.style.overflow = "unset";
      $('#myCanvasNav').fadeOut();
      $(window).trigger('resize');
    });
    $('.main-menu-mobile-btn-wrapper button').click(function() {
      document.getElementById("mySidenav").style.marginLeft = "0";
      document.body.style.marginLeft = "250px";
      document.body.style.marginRight = "-250px";
      document.body.style.overflow = "hidden";
      $('#myCanvasNav').fadeIn();
      $(window).trigger('resize');
    });
    $('#myCanvasNav').click(function() {
      $('#mySidenav .closebtn').trigger('click');
    });

    $('#mySidenav .dropdown-toggle').click(function(e) {
      console.log('click');
      e.preventDefault();
      e.stopPropagation();
      if( $(this).hasClass('open-mobile') ){
        $(this).removeClass('open-mobile').next('.dropdown-menu').slideUp();
      }
      else{
        $(this).addClass('open-mobile').next('.dropdown-menu').slideDown();
      }
    });

    //$('.mobile-searchbtn').click(function() {
    //  $('.mobile-search-wrapper').slideToggle();
    //});



  }
}


var featureSlider = {
  init: function(){
    
    var slider_speed = $('.slider-blocks-wrapper').attr("data-speed");
    var sliderAnimation = $('.slider-blocks-wrapper').attr("data-fade");
    var slider_adaptiveHeight = $('.slider-blocks-wrapper').attr("data-adaptiveHeight");
    
    $('.slider-blocks-wrapper').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      autoplay: true,
      arrows: true,
      autoplaySpeed: parseInt(slider_speed),
      fade: JSON.parse(sliderAnimation),
      adaptiveHeight: JSON.parse(slider_adaptiveHeight),
      cssEase: 'linear'
    });

  }
}